import React from "react";
import { TextField } from "@mui/material";
import EntityForm from "../../../../helpers/EntityForm";

const AnnouncementForm = ({
  announcement,
  longDescription,
}) => {
  return (
    <EntityForm isCreate={announcement === null}>
      <input name="announcementEntityId" readOnly hidden
             value={announcement?.announcementEntityId}/>
      <input name="userEntityId" readOnly hidden
             value={announcement?.userEntityId}/>
      <input name="oldLongDescription" readOnly hidden
             value={encodeURIComponent(longDescription)}
      />
      <TextField
        label="Label"
        type="text"
        id="label"
        name="label"
        required
        defaultValue={announcement?.label}
        variant="outlined"
      />
      <TextField
        label="Description"
        type="text"
        id="longDescription"
        name="longDescription"
        margin="normal"
        multiline={true}
        required
        defaultValue={longDescription}
        minRows={6}
        variant="outlined"
      />
    </EntityForm>
  );
};

export default AnnouncementForm;